<template>
  <div>
    <main-header/>
    <div class="aboutUs-bg">
      <nav-bar class="d-md-block d-none"/>
      <div class="row">
        <div class="col-10 mx-auto mt-5">
          <h1 class="col-auto text-center border-bottom-title mb-6">
            دانستی های انتشارات شاهکار قلم
          </h1>
        </div>
      </div>
      <div v-if="isPageLoaded" class="container ">
        <div class="row mb-8 ">
          <div v-for="item in articles " :key="item.id"
               class="col-12 col-sm-6 col-md-4 col-lg-3 mx-auto  border-10px-allSide grayColor">
            <router-link :to="{path: 'BlogPostsDetails/'+ item.BlogId + '/' + item.Title}">
              <v-img :alt=item.Title
                     :src="$replaceHttps(item.FileUrl)"
                     class="mx-auto border border-10px-Articles-image"></v-img>
            </router-link>
            <div class="border border-10px-Articles-body">
              <router-link :to="{path: 'BlogPostsDetails/'+ item.BlogId + '/' + item.Title}">
                <div class="pt-5 px-5 text-center primary-text font-16">{{
                    item.Title
                  }}
                </div>
              </router-link>
              <div class="pt-5 px-5 overflow-hidden black-text font-12 overflow-title"
                   v-html="item.description"></div>
              <v-divider></v-divider>
              <div class="row">
                <div class="col text-center black-text font-12">
                  <i class="fas fa-eye px-2 black-text"></i>
                  {{ item.Views }}
                </div>
                <div class="col text-center black-text font-12">
                  {{ $moment(item.CreateDate) }}
                  <i class="fas fa-calendar-alt px-2 black-text"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <v-dialog
          v-model="showLoaderDialog"
          hide-overlay
          persistent
          width="500">
        <v-card class="text-center py-5">
          <v-progress-circular
              color="primary"
              indeterminate
          ></v-progress-circular>
        </v-card>
      </v-dialog>
    </div>
    <Footer/>
    <navigation-drawer :drawer="drawer"/>
  </div>
</template>
<script>
import MainHeader from "@/components/mainHeader.vue";
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import NavigationDrawer from "@/components/navigationDrawer.vue";

export default {
  name: "BlogPosts",
  components: {NavigationDrawer, Footer, NavBar, MainHeader},

  metaInfo() {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  data: () => ({
    isPageLoaded: false,
    BlogPostDetail: {},
    showLoaderDialog: false,
    articles: [],
    drawer: false,

  }),
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Home/Blogs", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.articles = JSON.parse(result)
            this.isPageLoaded = true;
          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>
